import type { EnableRedirectionAllowedFeatureType } from './allowedFeaturesUtils';

export const getCrossSiteTenantIdFromAllowedFeature = (
	feature?: string | EnableRedirectionAllowedFeatureType,
): string | undefined => {
	if (!feature) {
		return undefined;
	}

	if (typeof feature === 'string') {
		try {
			const parsed = JSON.parse(feature);
			return parsed['enable-redirection']?.['cross-site-tenant-id'];
		} catch {
			return undefined;
		}
	}
	return feature['enable-redirection']?.['cross-site-tenant-id'];
};
